<template><ListFilter field="department" :options="opts" label="Отделение" @filter="$emit('filter',$event)" @openDetail="$emit('openDetail',$event)"/></template>
<script>
import ListFilter from './ListFilter.vue'
export default { name:'DepartmentFilter', components:{ListFilter}, data(){ return { opts:['C1','C2','D3','J2','K1','P','Q holocene'] } } }
</script>
